import React, { SetStateAction } from 'react';
import { ReactComponent as Close } from 'assets/header/close.svg'
import { ReactComponent as Down } from 'assets/common/download.svg'
import { ReactComponent as Down2 } from 'assets/header/download.svg'
import { ReactComponent as File } from 'assets/header/file.svg'
import CustomButton from '../CustomButton';
import { download } from 'components/function';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { IDocumentSelect, IFileInfo } from 'types/as';

interface IConfrimDialog {
    isOpen: boolean,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    documentSelect: IDocumentSelect
}

const DocumentPop = ({ isOpen, setIsOpen, documentSelect }: IConfrimDialog) => {

    const downloadAllFilesAsZip = async (files: any, zipName = 'files.zip') => {
        const zip = new JSZip();
        const flatList: IFileInfo[] = files

        try {
            const fetchFile = async (file: IFileInfo, idx: number) => {
                const response = await fetch(file.filePath);
                const blob = await response.blob();
                zip?.file(`${idx + 1}_${file.fileName}`, blob); // 파일 추가
            };

            await Promise.all(flatList.map(fetchFile));

            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, zipName);
        } catch (err) {
            console.log(err)
        }
    };

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                <div className="bg-white shadow-lg rounded-lg w-[600px] tablet:w-96 h-[50%] overflow-y-auto">
                    <div className='flex flex-col gap-4 h-full text-lg text-left'>
                        <div className='flex justify-between items-center gap-4 px-4 py-4 border-[#F8F8FA] border-b-2'>
                            <div className='leading-none'>
                                <p className='font-semibold text-xl'>{documentSelect.title}</p>
                                <p className='text-[#9D9EB7] text-sm'>{documentSelect.createAt}</p>
                            </div>
                            <Close className='cursor-pointer shrink-0' onClick={() => setIsOpen(false)} />
                        </div>
                        <div className='flex flex-col justify-between px-4 pb-4 h-full'>

                            <div className='flex flex-col flex-1 gap-4'>
                                {
                                    documentSelect.fileList.map((item, idx) => (
                                        <div
                                            className='flex justify-between items-center bg-[#F8F8FA] px-6 py-2.5 rounded-lg h-20 hover:underline cursor-pointer'
                                            onClick={() => download(item.filePath)}
                                            key={idx}
                                        >
                                            <div className='flex justify-center items-center pr-6 border-r h-full'><File /></div>
                                            <div className='pl-6 w-full text-[#9D9EB7] text-lg text-left leading-none'>
                                                <p className='font-semibold'>{item.fileName}</p>
                                            </div>
                                            <div className='px-6'><Down2 /></div>
                                        </div>
                                    ))
                                }
                            </div>

                            <div>
                                {
                                    documentSelect.fileList &&
                                    documentSelect.fileList.length > 1 &&
                                    <CustomButton
                                        className='bg-[#0ACF2E] mx-auto my-4 w-30 !min-w-400 !h-10 !text-sm shrink-0'
                                        Icon={Down}
                                        title='전체 다운로드'
                                        onClick={() => {
                                            downloadAllFilesAsZip(documentSelect.fileList, `${documentSelect.title}-${documentSelect.createAt}.zip`)
                                        }}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentPop;